import { Box, Modal, Grid, Button, Typography } from '@mui/material';
import { useContext } from 'react';
import ReviewContext from 'src/store/review-page-context';
import StepperContext from 'src/store/stepper-context';
import { colors } from 'src/styles/theme';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: `2px solid ${colors.primary.dark}`,
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  minWidth: '300px',
};

const NeedToItemize = () => {
  const { needToItemizeModal } = useContext(ReviewContext);
  const { setStepNo } = useContext(StepperContext);
  const { needToItemizeModalController } = needToItemizeModal;

  return (
    <>
      <Modal open={needToItemizeModalController.open}>
        <Box sx={style}>
          <Grid container sx={{ justifyContent: 'center', mb: '1rem' }}>
            <Grid item>
              <Typography component="h2">
                <p>
                  Your account requires you to itemize your assets, or you have chosen to itemize.
                </p>
                <p>
                  If you have mistakenly chosen to itemize, please change your itemization on{' '}
                  <b>Step 1</b>. Otherwise, please return to <b>Step 3</b> and enter your assets.
                </p>
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ justifyContent: 'right' }}>
            <Grid item>
              <Button
                type="submit"
                variant="outlined"
                onClick={() => {
                  setStepNo(0);
                }}
              >
                Change Itemization
              </Button>
            </Grid>
            <Grid item>
              <Button
                type="submit"
                variant="contained"
                onClick={() => {
                  setStepNo(2);
                }}
              >
                Go To Assets
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default NeedToItemize;
